import RowPlaceholder from './RowPlaceholder'

export default RowPlaceholder;
